import { Injectable } from '@angular/core';
import { GlobalSettings } from './global.settings';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
import { CommonService } from './common.service';
import Utils from './utils';
import EsConst  from './elasticSearchConstants';
import { format } from 'date-fns';

@Injectable()
export class ElasticService {
    // Request payload for the elastic search api
    esBody: any;
    // hold response count
    itemCount: any = 0;
    // holds base url
    baseURL = 'https://api.' + GlobalSettings.HOSTNAME + '/server/';
    // holds document id from projects
    documentIdentifierList:any = [];
    //holds cfdocument result count
    docResultCount:any = 0;
    // hold pagerange object
    pageRangeData:any = {};
    //cumalative search amount from APIS
    cumalativeSrchRslt:any = 0
    //document node count
    documentCount:any = 0;
    //hold item total count
    itemResultCount: any =0;
    //hold total fetched count
    totalfetchedResult: any = 0;
    //total prev call data fetched
    totalfetchedResultPrev: any = 0;
    constructor(
        private router: Router,
        private shareService: SharedService,
        private service: CommonService
    ) {}

    /**
     * Function to pass the data for ES payload creation
     *
     * @param searchFilters search optional filters
     * @param searchKeyword         search text keyword from search bar
     * @param searchResult          Represents search result sets i.e an array
     * @param loadMore              load more pagination option
     * @param filterSelected        search filter is selected or not
     * @param additionalAttributes  Additional attributes if needed for api
     * 
     * @return null|object elastic search API body
     */
    callElasticSearchAPI(
        searchFilters,
        searchKeyword,
        searchResult,
        loadMore,
        filterSelected,
        additionalAttributes?
    ) {
        searchResult = ( loadMore === 1 || loadMore === -1 ) ? searchResult : [];
        if(this.router.url.indexOf('/detail') !== -1){
            let addtionDataindex = searchFilters.findIndex((x) =>
                x.filter_type !== 'taxonomy_id'
                && x.filter_type !== 'project_id')
            if(addtionDataindex === -1){
                searchFilters = [];
            }
        }
        return new Promise(async (resolve, reject) => {
            try {
                if (!((searchKeyword && searchKeyword.trim().length > 2)
                    || (filterSelected && searchFilters.length > 0)
                )) {
                    this.shareSearchResultSet(searchResult);
                    return resolve(searchResult);
                }

                return resolve(
                    this.createElasticSearchRequestPayload(
                        searchFilters,
                        searchKeyword,
                        searchResult,
                        loadMore,
                        additionalAttributes
                    )
                );
            } catch (e) {
                return reject(e);
            }
        });
    }

    /**
     * Emit search result to other area
     * 
     * @param searchResult Concated Search results
     * @param res          Response from the search api
     */
    shareSearchResultSet(searchResult, res?, searchApiResults?) {
        this.shareService.treeSearchResultEvent.next({
            searchData: searchResult,
            showSearchList: true,
            totalSearchResult: res?.hits.total.value,
            totalHitResultCount: res?.hits.hits.length,
            isFirstPage: this.pageRangeData.isFirstPage,
            searchApiResults: searchApiResults,
            pageRangeData: this.cumalativeSrchRslt,
            totalfetchedResult: this.totalfetchedResult
        });
    }

    /**
     *  Function to call Backend API 
     * 
     * @return null|object return api response
     */
    callSearchAPI() {
        return new Promise(async (resolve, reject) => {
            this.service.postService(
                GlobalSettings.ELASTIC_SEARCH,
                this.esBody,
                -1,
                false,
                false
            ).then((res:any) => {
                const results: any = [];
                res.hits.hits.forEach((element) => {
                    results.push(element);
                });
                results.responseCount = res.hits.hits.length;
                results.responseData = res;
                resolve(results);
            })
            .catch((ex) => {
                console.log('update user', ex);
                reject(ex);
            });
        });
    }

    /**
     * Filter unique data in array
     * 
     * @param value  Array index value
     * @param index  Index of array
     * @param self   self index data
     * 
     * @return       Boolean true false
     */
    onlyUniqueIdentifier(value, index, self) {
        return self.indexOf(value) === index;
    }

    /**
     * Chaining function for common ES payload creation with taxonomy id handling
     * 
     * @param searchFilters  .......Selected filters
     * @param searchKeyword  .......Typed keyword in search panel
     * @param searchResult   .......Store search results array 
     * @param loadMore              Load more option enabled or disabled
     * @param additionalAttributes  Additional attributes if needed for a
     * 
     * @return Object ES payload for different case
     */
    async createElasticSearchRequestPayload(
        searchFilters,
        searchKeyword,
        searchResult,
        loadMore,
        additionalAttributes?
    ) {
        if (this.router.url.indexOf('detail') !== -1
            && additionalAttributes && additionalAttributes.taxonomyId && !loadMore)
        {
            searchFilters.push({
                filter_type: 'taxonomy_id',
                filter_value: additionalAttributes.sourceTaxonomyId
                    ? additionalAttributes.sourceTaxonomyId
                    : additionalAttributes.taxonomyId
            });
        }

        return this.commonEsPayload(
            searchFilters,
            searchKeyword,
            searchResult,
            loadMore,
            additionalAttributes
        );
    }

    /**
     * Set payload and Call API function
     * 
     * @param searchFilters        Selected filter
     * @param loadMore             Load more option enabled or disabled
     * @param searchResult         Store search results array 
     * @param type                 API call type i.e document/item/project/association
     * @param searchKeyword        Typed keyword in search panel
     * @param itmPgCnt             Pagination count
     * 
     * @return API Respose data
     */
    async setPayload(
            searchFilters,
            loadMore,
            searchResult,
            type,
            searchKeyword,
            itmPgCnt = 0
    ) {
        try {
            const orgId = localStorage.getItem('orgDetails')
                ? JSON.parse(localStorage.getItem('orgDetails')).orgId
                : '';

            let objESPayload : any = '';

            const uniqueSearchResults: any = this.createUniqueSearchOptions(
                searchFilters
            );

            const apiIndexdata =  this.getIndex(type)

            let startPoint = (this.pageRangeData.nextPage
                && this.pageRangeData.apiIndex === apiIndexdata && loadMore === 1 )
                    ? this.pageRangeData.nextPage
                    : 0;
            
            // if(loadMore === 1 && type === 'items') {
            //     let startPointCount = searchResult.filter(items =>
            //         items._index === 'cfitems').length;
            //     startPoint = ( this.itemCount !== 0 ) ? startPointCount : 0;
            // }

            if(loadMore === 1 && type === 'document'){
                startPoint = searchResult.length;
            }

            if(loadMore === -1){
                startPoint = (this.pageRangeData.prevPage >= 0) 
                    ? this.pageRangeData.prevPage
                    : 0;
                itmPgCnt = (this.pageRangeData.prevPage < 0
                    && this.pageRangeData.apiIndex === apiIndexdata)
                        ? this.pageRangeData.currentIndex
                        : itmPgCnt
            }

            let isPrjctLst = (this.router.url.indexOf('project/list') !== -1)
                ? true
                : false;

            let isUnique = (apiIndexdata === EsConst.ES_ASSOC_INDEX)
                ? EsConst.assocUniqueKey
                : {}

            let isCollapse = (apiIndexdata === EsConst.ES_ASSOC_INDEX)
            ? EsConst.assocCollapseValue
            : ""
            
            this.esBody = {
                start: startPoint,
                size: itmPgCnt === 0 ? GlobalSettings.ES_SEARCH_OFFSET:itmPgCnt,
                hasProject : isPrjctLst,
                index: apiIndexdata,
                search_match: {},
                org_id: orgId,
                search_filter: [],
                response: this.getResponse(type),
                unique_search: isUnique,
                collapse : isCollapse
            };

            this.pageRangeData = this.getPageRange(
                    startPoint, 
                    this.esBody.size, 
                    searchResult,
                    this.esBody.index);

            Object.entries(uniqueSearchResults).forEach(([key, value]: any) => {

                if (key === 'update_on') {
                    let dayCount = 0;

                    if (value.findIndex((x) => x === EsConst.THIRTY_DAY_KEY) !== -1) {
                        dayCount = EsConst.THIRTY_DAY_VALUE
                    }
                    else if(value.findIndex((x) => x === EsConst.SEVEN_DAY_KEY) !== -1) {
                        dayCount = EsConst.SEVEN_DAY_VALUE;
                    }

                    value = { 
                        gte: Utils.dateCalculation(dayCount),
                        lte: format(new Date(), 'YYYY-MM-DD') 
                    };
                    objESPayload = { range: {[this.getFilterType(key, type)]: value} };
                }
                else{
                    objESPayload=    {[this.getFilterType(key, type)]: value}
                }
                this.esBody.search_filter.push(objESPayload);
            });

            if (!searchKeyword) {
                return await this.callSearchAPI();
            }

            if (searchKeyword.length <= 2) {
                return await this.callSearchAPI();
            }

            if(type === 'projects'){
                return await this.callSearchAPI();
            }

            let ObjPayload : any = {
                    'fullStatement': searchKeyword,
                    'humanCodingScheme': searchKeyword
                }

            if (type === 'document') {
                ObjPayload = { 'title': searchKeyword }
            }

            this.esBody.search_filter.push(ObjPayload);
            return await this.callSearchAPI();
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Function for create unique filteration
     * 
     * @param searchFilters Selected search filter
     * 
     * @return object Unique search filter for search
     */
    createUniqueSearchOptions(searchFilters) {
        let searchResults = [];
        const groups = Object.create(null);
        searchFilters.forEach((a: any) => {
            groups[a.filter_type] = groups[a.filter_type] || [];
            a.filter_type === 'node_type_id'
                ? groups[a.filter_type].push(a.label)
                : groups[a.filter_type].push(a.filter_value);
        });

        searchResults = Object.keys(groups).map((k) => {
            return { [k]: groups[k] };
        });

        return Object.assign({}, ...searchResults);
    }

    /**
     * Functionality for return filter type for ES payload
     * 
     * @param filterType Filter type which is applied
     * @param type       Type of API request index
     * 
     * @return          Filter type index for search
     */
    getFilterType(filterType: any, type: any) {
        switch (filterType) {
            case EsConst.FLTR_TYP_NODE:
                return type === EsConst.ES_DOC_TYPE
                    ? EsConst.FLTR_KEY_NODE_TYPE_ID
                    : EsConst.FLTR_KEY_CFITEMTYPEURI;

            case EsConst.FLTR_TYP_UPDTON:
                return EsConst.LAST_CHANGE_DATE_KEYWORD;

            case EsConst.FLTR_TYP_DOC:
                return `${EsConst.FLTR_TYP_DOC}.${EsConst.FLTR_KEYWORD}`

            case EsConst.FLTR_TYP_ADOPT:
                return EsConst.ADOPTION_STATUS_KEYWORD;

            case EsConst.FLTR_TYP_ASSOC:
                return type === EsConst.ES_ASSOC_TYPE
                    ? EsConst.ASSOCIATION_KEYWORD
                    : EsConst.ASSOCIATION_KEYWORD_ITEMS;

            case EsConst.FLTR_TYP_UPDTBY:
                return EsConst.UPDATED_BY_KEYWORD;

            case EsConst.FLTR_TYP_ID:
                return `${EsConst.FLTR_TYP_ID}.${EsConst.FLTR_KEYWORD}`;

            case EsConst.FLTR_TYP_PROJID:
                return (this.getIndex(type) === 'cfprojects')
                    ? `${EsConst.FLTR_TYP_ID}.${EsConst.FLTR_KEYWORD}`
                    : `${EsConst.FLTR_TYP_PROJID}.${EsConst.FLTR_KEYWORD}`;

            case EsConst.FLTR_TYP_WORKFID:
                return (this.getIndex(type) === 'cfprojects')
                    ? EsConst.WORKFLOW_KEYWORD
                    : EsConst.PROJECT_WORKFLOW_KEYWORD;

            case EsConst.FLTR_TYP_TXNMYID:
                return (type === EsConst.ES_DOC_TYPE
                        && this.router.url.indexOf('project/detail') === -1)
                    ? `${EsConst.FLTR_TYP_ID}.${EsConst.FLTR_KEYWORD}`
                    : `${EsConst.FLTR_TYP_DOC}.${EsConst.FLTR_KEYWORD}`;

            default:
                return filterType;
        }
    }

    /**
     * Function for get request type for API i.e  cfdocument|cfitems etc.
     *
     * @param type Type of index
     *
     * @return The index name for request API
     */
    getIndex(type) {
        switch (type) {
            case EsConst.ES_DOC_TYPE:
                return EsConst.ES_DOC_INDEX;
            case EsConst.ES_ITM_TYPE:
                return EsConst.ES_ITM_INDEX;
            case EsConst.ES_ASSOC_TYPE:
                return EsConst.ES_ASSOC_INDEX;
            case EsConst.ES_PROJ_TYPE:
                return EsConst.ES_PROJ_INDEX;
            default:
                return EsConst.ES_DOC_INDEX;
        }
    }

    /**
     * Function for defining response index based on request type
     * 
     * @param type Type of API request index
     *
     * @return  API response index names
     */
    getResponse(type) {
        const response = ['identifier', 'lastChangeDateTime'];
        switch (type) {
            case 'document':
                return response.concat([
                    'title',
                    'CFPackageURI',
                    'nodeType',
                    'document_id',
                    'project_id'
                ]);

            case 'items':
                return response.concat([
                    'CFDocumentURI',
                    'CFItemTypeURI',
                    'Hierarchy',
                    'fullStatement',
                    'humanCodingScheme',
                    'item_id',
                    'project_id'
                ]);

            case 'associations':
                return response.concat(['originNodeURI']);
            
            case 'projects':
                    return response.concat(['document_id']);

            default:
                return response;
        }
    }

    /**
     * Function for creation ES payload for different filters
     * 
     * @param searchFilters         Selected filters
     * @param searchKeyword         Typed keyword in search panel
     * @param searchResult          Store search results array
     * @param loadMore              Load more option enabled or disabled
     * @param additionalAttributes  Additional attributes if needed
     * 
     * @return Backend API result
     */
    async commonEsPayload(
        searchFilters,
        searchKeyword,
        searchResult,
        loadMore,
        additionalAttributes?
    ){
        let workflowSearchOptionFilter = [];
        let searchResponse: any = [];
        let identifiersList:any = [];
        let searchApiResults:any = [];
        let docResult: any = [];
        let showResultData = [];

        docResult.responseCount = 0
        docResult.responseData =[];

        if((!loadMore
            || (this.docResultCount > GlobalSettings.ES_SEARCH_OFFSET
                && searchResult.filter(items =>
                    items._index === 'cfdocument').length !== this.docResultCount
            )) ||
            (loadMore === -1
                && this.pageRangeData.currentIndex === 0
                && this.pageRangeData.apiIndex === 'cfitems')){

            if((searchFilters.findIndex((x) =>
                x.filter_type === 'project_workflow_id')!== -1)) 
            {
                let arr = [
                    'project_workflow_id',
                    'project_id'
                ];
                searchFilters.forEach((element) => {
                    //if(element.filter_type !== 'item_association_type') {
                        (arr.indexOf(element.filter_type) !== -1)
                            ? workflowSearchOptionFilter.push(element)
                            : identifiersList.push(element)
                    //}
                });
                identifiersList = await this.getProjAssocData(
                    identifiersList,
                    workflowSearchOptionFilter,
                    loadMore,
                    searchResult,
                    'projects',
                    searchKeyword
                );
            }

            let docIdentifier = (identifiersList.length>0)
                ? identifiersList
                : searchFilters;

            docResult = await this.setPayload(
                docIdentifier,
                loadMore,
                searchResult,
                'document',
                searchKeyword
            );
            this.documentCount = docResult.responseData?.hits.total.value;
        }
        searchResponse =  docResult.responseData;
        this.docResultCount = searchResponse.hits
            ? searchResponse?.hits.total.value
            : 0;

        showResultData = showResultData.concat(docResult)
        searchApiResults = searchApiResults.concat(searchResult, docResult);

        if (docResult.responseCount < GlobalSettings.ES_SEARCH_OFFSET) {
            identifiersList = (identifiersList.length>0)
                ? identifiersList 
                : searchFilters;
            
            let itemIdentifier = JSON.parse(JSON.stringify(identifiersList));

            if(this.router.url.indexOf('/detail') !== -1 && additionalAttributes && additionalAttributes.taxonomyId){
                let taxonomyIndex = itemIdentifier.findIndex(
                    (x) => x.filter_type === 'taxonomy_id'
                );
                itemIdentifier[taxonomyIndex].filter_value = additionalAttributes.taxonomyId;
            }

            let itemResults: any = await this.setPayload(
                itemIdentifier,
                loadMore,
                searchResult,
                'items',
                searchKeyword,
                GlobalSettings.ES_SEARCH_OFFSET - docResult.responseCount
            );

            if(loadMore === -1 && itemResults.responseCount 
                    < GlobalSettings.ES_SEARCH_OFFSET){
                docResult = await this.setPayload(
                    (identifiersList.length>0) ? identifiersList : searchFilters,
                    loadMore,
                    searchResult,
                    'document',
                    searchKeyword,
                    GlobalSettings.ES_SEARCH_OFFSET - itemResults.responseCount
                );
                showResultData = showResultData.concat(docResult);
            }

            if (itemResults) {
                this.itemResultCount = itemResults.responseData
                    ? itemResults.responseData?.hits.total.value
                    : 0;
                this.itemCount = itemResults.responseCount;
                searchResponse = itemResults.responseData;
                showResultData = showResultData.concat(itemResults);
                searchApiResults = searchApiResults.concat(itemResults);
            }
        }
        if(this.documentCount > GlobalSettings.ES_SEARCH_OFFSET){
            let itemResultsDataCount: any = await this.getItemCountApi(
                (identifiersList.length>0) ? identifiersList : searchFilters,
                'items'
            )
            this.itemResultCount = itemResultsDataCount.responseData?.hits.total.value
        }

        this.cumalativeSrchRslt =  this.itemResultCount + this.documentCount;
        if(!loadMore){
            this.totalfetchedResult = showResultData.length;
        }
        if(loadMore){
            this.totalfetchedResult = (loadMore === 1)
                ? this.totalfetchedResult + showResultData.length
                : this.totalfetchedResult - this.totalfetchedResultPrev
        }
        
        this.shareSearchResultSet(showResultData, searchResponse, searchApiResults);
        this.totalfetchedResultPrev = showResultData.length;
        return searchApiResults;
    }

    /**
     *  Function for get identifiers in case or association, workflow and project
     * 
     * @param identifiersList                Selected identifier list
     * @param associationSearchOptionFilter  Identifier association workflow
     * @param loadMore                       Load more option enable or disable
     * @param searchResult                   Store search results array
     * @param assocType                      Type document|item|project etc
     * @param searchKeyword                  Typed keyword in search panel
     * 
     * @return Array set if identifiers 
     */
    async getProjAssocData(
        identifiersList,
        assocWrkflwSearchFilter,
        loadMore,
        searchResult,
        assocType,
        searchKeyword
    ) {
        const assocProjResults: any = await this.setPayload(
            assocWrkflwSearchFilter,
            loadMore,
            searchResult,
            assocType,
            searchKeyword
        );

        if (assocProjResults !== 'undefined' && assocProjResults && assocProjResults.length <= 0) {
            identifiersList = [];
            return identifiersList;
        }

        assocProjResults.forEach((element) => {
            let assocProjObj = {
                filter_type: (assocType === 'projects')
                    ? 'project_id.keyword'
                    : 'identifier',
                filter_value: (assocType === 'projects')
                    ? element._source.identifier
                    : element._source.originNodeURI.identifier,
            };
        
            let assocProjFind = identifiersList.find(ilI =>
                (ilI.filter_value == assocProjObj.filter_value));
            if(!assocProjFind){
                identifiersList.push(assocProjObj)
            }

            if (assocType === 'projects') {
                this.documentIdentifierList.push({
                    filter_type: 'document_id',
                    filter_value: element._source.document_id
                })
            }
        });


        return identifiersList;
    }

    /**
     * 
     * @param pageStart   Elastic index start count
     * @param pageLength  Number of items need to fetch from ES
     * @param page        All result data
     * @param index       Api index
     * @returns Object for pagerange
     */
    getPageRange(pageStart, pageLength, page = [], index) {
        let isLastPage = false;
        let isFirstPage = false;
        if (pageStart == 0) {
            isFirstPage = true;
        };

        if (page.length < pageLength) {
            isLastPage = true;
        };


        return {
            nextPage: pageStart + pageLength,
            prevPage: pageStart - pageLength,
            isLastPage: isLastPage,
            isFirstPage: isFirstPage,
            data: page,
            apiIndex: index,
            currentIndex: pageStart
        };
    };

    /**
     * 
     * @param searchFilters selected filter
     * @param type Api index type
     * @returns count for cfitems
     */
    async getItemCountApi(searchFilters,type){
        try {
            let itemIdentifier = JSON.parse(JSON.stringify(searchFilters));

            const orgId = localStorage.getItem('orgDetails')
                ? JSON.parse(localStorage.getItem('orgDetails')).orgId
                : '';
        
            let objESPayload : any = '';
        
            const uniqueSearchResults: any = this.createUniqueSearchOptions(
                itemIdentifier
            );
        
            const apiIndexdata =  this.getIndex(type)

            this.esBody = {
                start: 0,
                size: 0,
                hasProject : 0,
                index: apiIndexdata,
                search_match: {},
                org_id: orgId,
                search_filter: [],
                response: this.getResponse(type),
            };
            
            Object.entries(uniqueSearchResults).forEach(([key, value]: any) => {

                if (key === 'update_on') {
                    let dayCount = 0;
        
                    if (value.findIndex((x) => x === EsConst.THIRTY_DAY_KEY) !== -1) {
                        dayCount = EsConst.THIRTY_DAY_VALUE
                    }
                    else if(value.findIndex((x) => x === EsConst.SEVEN_DAY_KEY) !== -1) {
                        dayCount = EsConst.SEVEN_DAY_VALUE;
                    }
        
                    value = { 
                        gte: Utils.dateCalculation(dayCount),
                        lte: format(new Date(), 'YYYY-MM-DD') 
                    };
                    objESPayload = { range: {[this.getFilterType(key, type)]: value} };
                }
                else{
                    objESPayload=    {[this.getFilterType(key, type)]: value}
                }
                this.esBody.search_filter.push(objESPayload);
            });

            return await this.callSearchAPI();
        }catch (error) {
        console.log(error);
        }
    }
}
